import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../../components/buttons/button";
import { TextInput } from "../../../../components/inputs/textInput";
import { AuthHeader } from "../../../../components/typography/authHeader";
import { useAdminTwoFaMutation } from "../../../../redux/features/admin/auth/auth.api";
import { authSliceActions } from "../../../../redux/features/auth/auth.slice";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { TwoFaSchema } from "../../../../utils/validations";
import { useState } from "react";

export const TwoFaPage = () => {
  const [twoFa, { isLoading, isError }] = useAdminTwoFaMutation();
  const [useBackup, setUseBackup] = useState(false);

  const { adminProfile: stateProfile } = useAppSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { values, handleBlur, handleChange, handleSubmit, errors, touched } =
    useFormik({
      initialValues: {
        email: stateProfile?.email,
        twoFaCode: "",
        backupCode: "",
      },
      validationSchema: TwoFaSchema,
      onSubmit: async (vals) => {
        const response = await twoFa(
          useBackup
            ? { email: vals.email, backupCode: vals.backupCode }
            : { email: vals.email, twoFaCode: vals.twoFaCode },
        );
        if (response.data?.data.adminData) {
          const adminData = response.data.data.adminData;
          dispatch(
            authSliceActions.signAdminIn({
              profile: adminData,
              token: adminData.token,
            }),
          );
          navigate("/overview");
        }
      },
    });

  return (
    <form className="w-full" onSubmit={handleSubmit}>
      <AuthHeader
        header="Verify your login"
        text={
          <span>
            Enter the 6-digit verification code generated by your authenticator
            app
          </span>
        }
      />

      <div className="mt-10 flex flex-col gap-5">
        {useBackup ? (
          <TextInput
            type="text"
            name="backupCode"
            value={values.backupCode}
            placeholder="Enter Backup Code"
            onChange={handleChange}
            autoFocus={true}
            onBlur={handleBlur}
            hasTitle
            title="Backup Code"
            errors={
              isError
                ? "Wrong or expired code. Please, check the code and try again."
                : errors.backupCode && touched.backupCode
                  ? errors.backupCode
                  : ""
            }
          />
        ) : (
          <TextInput
            type="text"
            name="twoFaCode"
            value={values.twoFaCode}
            placeholder="Enter 6-digit Code"
            onChange={handleChange}
            autoFocus={true}
            onBlur={handleBlur}
            hasTitle
            title="6-digit Verification Code"
            errors={
              isError
                ? "Wrong or expired code. Please, check the code and try again."
                : errors.twoFaCode && touched.twoFaCode
                  ? errors.twoFaCode
                  : ""
            }
          />
        )}

        <Button
          type="submit"
          text="Continue"
          variation="primary"
          className="mt-5"
          loading={isLoading}
          disabled={isLoading}
        />
        <div className="flex items-center justify-center">
          <p
            className="cursor-pointer text-sm font-bold text-blue-500"
            onClick={() => setUseBackup((prev) => !prev)}
          >
            {useBackup
              ? "Use authenticator app instead"
              : "Use backup code instead"}
          </p>
        </div>
      </div>
    </form>
  );
};
